import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInkscapeComponent } from './simple-icons-inkscape.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInkscapeComponent ],
    exports:      [ SimpleIconsInkscapeComponent ],
    bootstrap:    []
})
export class SimpleIconsInkscapeModule {}
